export const KEY = 'dynamicCatalog';
